const container = document.querySelector("#ff-product-grid-unvailable");

const loginButton = document.querySelector("#ff-login-button");

loginButton.addEventListener("click", async (event) => {
  event.preventDefault();
  const form = document.querySelector("#customer_login");
  const email = document.querySelector("#CustomerEmail");
  const password = document.querySelector("#CustomerPassword");
  if(email && password) {
    await fetch('/apps/tao-account/customers/login', {
      method: 'POST',
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({'email': email.value, 'password': password.value} ),
    })
    .then(result => result.json())
    .then(data => {
      
      data.accessToken && 
        localStorage.setItem('userAccesToken', data.accessToken);
        form.submit();
    })
    .catch(error => console.log('error', error));
  }
  
});